<template>
  <!-- 消息条滚动播放,只需要在组件中添加多个div，组件将按div进行滚动 -->
  <div class="message-scroll">
    <div class="message-container">
      <slot/>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.message-scroll{
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  white-space: nowrap;
  .message-container{
    display: inline-block;
    padding-top: 30px; /* 初始偏移 */
    animation: marquee 10s linear infinite; /* 应用动画 */
  }
}
@keyframes marquee {
  from { transform: translateY(0); }
  to { transform: translateY(-100%); }
}
</style>